import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "@/assets/icons/CustomIcon";

const InfoLine: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path
      clipRule="evenodd"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 10L10.5 13.75M10.5 7.22046V7.1875M3 10C3 5.85786 6.35787 2.5 10.5 2.5C14.6421 2.5 18 5.85787 18 10C18 14.1421 14.6421 17.5 10.5 17.5C6.35786 17.5 3 14.1421 3 10Z"
      fillRule="evenodd"
    />
  </CustomIcon>
);

export default InfoLine;